export default {
    defensible_prep_and_hold: {
        name: "Defensible Prep And Hold",
        url: "nwcg_triage/defensible_prep_and_hold",
    },
    defensible_stand_alone: {
        name: "Defensible Stand Alone",
        url: "nwcg_triage/defensible_stand_alone",
    },
    non_defensible_prep_and_leave: {
        name: "Non Defensible Prep And Leave",
        url: "nwcg_triage/non_defensible_prep_and_leave",
    },
    non_defensible_rescue_drive_by: {
        name: "Non Defensible Rescue Drive By",
        url: "nwcg_triage/non_defensible_rescue_drive_by",
    },
    unknown: {
        name: "Unknown",
        url: "nwcg_triage/unknown",
    },
}
